import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { H1Text } from '../../styles/AvantTypography'
import { Header } from "../../components/Header/Header"
import { useHistory } from "react-router"
import { Take, State } from "../../types/types"
import { connect } from 'react-redux'
import { Section } from '../../app/section/models/Section'
import ApiService, { ResponseData } from '../../services/ApiService'
import HelperService from '../../services/HelperService'
import axios from 'axios'

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  color: '#007668',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  textAlign: 'center',
  fontFamily: 'Arial, sans-serif',
})

const Wrapper = styled('div')({
  width: '690px',
  padding: '16px',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: 0,
})

const Head = styled(Box)(({ theme }) => ({
  backgroundColor: '#d3ffd8',
  width: '100%',
  fontWeight: '700',
  fontSize: '32px',
  border: '2px solid #80D9B9',
  borderBottom: '2px solid #80D9B9',
  padding: theme.spacing(2),
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'center',
  borderRadius: 0,
  gap: theme.spacing(1),
  justifyContent: 'left',
  position: 'relative',
  zIndex: 1,
}))

const ContentBox = styled('div')({
  width: '100%',
  backgroundColor: '#fff',
  border: '0px 2px 2px 2px solid #0000001A',
  borderTop: 'none',
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
  padding: '16px',
  textAlign: 'left',
  borderRadius: 0,
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
})

const Paragraph = styled('p')({
  color: '#000',
  fontSize: 'medium',
  margin: '8px 0',
})

const TextLine = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  textAlign: 'left',
  marginRight: '40px',
})

const StyledCheckIcon = styled(CheckCircleIcon)({
  color: "#007668",
  fontSize: "40px",
})

interface StateToProps {
  take: Take
}

function mapStateToProps(state: State): StateToProps {
  return {
    take: state.app.take!
  }
}
interface LocationState {
  detail: Section
}
const Logout: React.FC<StateToProps> = (props) => {
  const history = useHistory<LocationState>()
  const [apiResponse, setApiResponse] = useState<ResponseData | null>(null)

  const getResponseByeBye = () => {
    ApiService.getByeByePage()
      .then(response => {
        if (response.error) {
          setApiResponse({ error: true, errorDescription: response.errorDescription, response: null })
        } else {
          setApiResponse(response)
        }
      })
      .catch(error => {
        console.error("Error:", error)
        setApiResponse({ error: true, errorDescription: error.message, response: null })
      }).finally(() => {
        axios.defaults.headers.common["X-Avant-Auth-Token"] = ""
        localStorage.clear()
      })
  }
  useEffect(() => {
    if (props.take === null) {
      HelperService.logout(history?.location?.state?.detail)
    }
    else {
      getResponseByeBye()
    }
    window.history.pushState(null, "", window.location.href)

    const handleBackButton = () => {
      history.replace("/test")
      setTimeout(() => {
        window.history.pushState(null, "", window.location.href)
      }, 0)
    }

    window.addEventListener("popstate", handleBackButton)

    return () => {
      window.removeEventListener("popstate", handleBackButton)
    }
  }, [])
  return (
    <>
      <Header />
      {props.take && props.take.availablePanels?.length > 0 ? (
        <Container>
          <Wrapper>
            <Head component="div">
              <StyledCheckIcon />
              <div dangerouslySetInnerHTML={{ __html: apiResponse && apiResponse.response && apiResponse.response["inprogressheader"] ? apiResponse.response["inprogressheader"] : '' }} />
            </Head>
            <ContentBox>
              <H1Text style={{ marginRight: '196px', fontSize: '24px', fontWeight: '700px',color:'#000' }}> How To Resume Your Test</H1Text>
              <Paragraph>
                <TextLine style={{ marginRight: "67px" }}>
                  <div dangerouslySetInnerHTML={{ __html: apiResponse && apiResponse.response && apiResponse.response["inprogresscontent"] ? apiResponse.response["inprogresscontent"] : '' }} />
                </TextLine>

              </Paragraph>
            </ContentBox>
          </Wrapper>
        </Container>
      ) : (
        <Container>
          <Wrapper>
            <Head component="div">
              <StyledCheckIcon />
              <div dangerouslySetInnerHTML={{ __html: apiResponse && apiResponse.response && apiResponse.response["completedheader"] ? apiResponse.response["completedheader"] : '' }} />
            </Head>
            <ContentBox>
              <H1Text style={{ marginRight: '140px', fontSize: '24px', fontWeight: '700px',color:'#000' }}>Close Your Proctoring Session</H1Text>
              <Paragraph>
                <TextLine style={{ marginRight: "6px" }}>
                  <div dangerouslySetInnerHTML={{ __html: apiResponse && apiResponse.response && apiResponse.response["completedcontent"] ? apiResponse.response["completedcontent"] : '' }} />

                </TextLine>
              </Paragraph>
            </ContentBox>
          </Wrapper>
        </Container>
      )}
    </>
  )
}
export default connect(mapStateToProps)(Logout)
